import Lenis from "lenis";

const lenis = new Lenis({
  lerp: 0.1, // Smoothing intensity — lower = snappier, higher = floatier
  smoothWheel: true, // Smooth mouse wheel (on by default)
  syncTouch: false, // Leave native on mobile (best for UX)
  autoRaf: true,
});
